import React, { Suspense } from 'react';
import GlobalLoader from '../GlobalLoader/GlobalLoader';

const LazyLoader =
  <P extends object>(Component: React.ComponentType<P>) =>
  (props: any) =>
    (
      <Suspense fallback={<GlobalLoader isLoading />}>
        <Component {...props} />
      </Suspense>
    );

export default LazyLoader;
